import common from './zh-CN/common';
import formatter from './zh-CN/formatter';

export default {
  ...common,
  ...formatter,
};
